import { RouteType } from "types/RouteType";
import PlantCapacityStore from "./PlantCapacityStore";

const PlantCapacityRoute: RouteType = {
  name: "Plant Capacity",
  path: "/batch-plant/capacity",
  layout: "/app",
  group: "Batch Plant",
  requiresAuth: true,
  requiresPermission: false,
  viewportCard: {
    header: {
      title: "Plant Capacity",
      component: () => import("./PlantCapacity.Header"),
      enableRefreshButton: true,
      enableBackButton: true,
    },
    body: {
      component: () => import("./PlantCapacity.Body"),
      grayBackground: true,
    },
  },
  beforeEnter: async ({ rootStore }) => {
    // Initialize store if not exists
    if (!rootStore.plantCapacityStore) {
      rootStore.plantCapacityStore = new PlantCapacityStore(rootStore);
    }
    // Reset to clean state when entering
    const store = rootStore.plantCapacityStore as PlantCapacityStore;
    store.reset();
    return true;
  },
};

export default PlantCapacityRoute;
